import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=8a767660&scoped=true&"
import script from "./partners.ts?vue&type=script&lang=ts&"
export * from "./partners.ts?vue&type=script&lang=ts&"
import style0 from "./partners.scss?vue&type=style&index=0&id=8a767660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a767660",
  null
  
)

export default component.exports